(function() {
    var eventItemList = '<li class="lists"><div class="list-inner">' +
        '<a href="{{eventUrl}}" target="{{#if eventTarget == "self"}}_self{{#else}}_blank{{/if}}" data-ec-promotion="{{ecPromotion}}">' + //BTOCSITE-2065 : 이벤트&기획전 페이지 내 데이터레이어 삽입 (수정 작업 요청) 2021-09-02
            '<span class="thumb">' +
                '<img src="/lg5-common/images/icons/noimage.svg" data-src="{{eventListThumbnailPath}}" alt="{{eventListThumbnailAltText}}" aria-hidden="true">' +
                '{{#if eventEndFlag != "N"}}<span class="event-end"><em>종료된 이벤트</em></span>{{/if}}' +
                // '<span class="flag-wrap bg-type"><span class="flag"><span class="blind">제품 카테고리</span>{{categoryName}}</span></span>' +
            '</span>' +
            '<div class="info">' +
                '<div class="flag-wrap bar-type"><span class="flag"><span class="blind">이벤트 구분</span>{{eventGubun}}</span><span class="flag"><span class="blind">이벤트 유형</span>{{eventType}}</span></div>' +
                '<p class="tit"><span class="blind">이벤트 제목</span>{{eventTitle}}</p>' +
                '<p class="date"><span class="blind">이벤트 기간</span>{{eventFromDate}}~{{eventToDate}}</p>' +
            '</div>' +
        '</a>' +
        '{{#if winAnnouncementFlag != "N"}}<a href="{{#if eventId}}/benefits/event/eventWin-{{eventId}}{{/if}}" class="btn-link"><span>당첨자 발표</span></a>{{/if}}' +
    '</div></li>';

    //BTOCSITE-68769 : 이벤트 메뉴 내 제품카테고리 필터 변경 요청
    var allCategory = '<li><a href="#all">전체</a></li>';
    var eventCategoryList = '<li><a href="#{{categoryId}}">{{categoryName}}</a></li>';

    function funcReady() {
        var KRP0022 = {
            init: function() {
                self.$KRP0022 = $('.KRP0022').first();
                self.$tab = self.$KRP0022.find('div.ui_stickyTab');
                self.$list = self.$KRP0022.find('ul.box-list-inner');
                self.$noData = self.$KRP0022.find('div.no-data');

                //BTOCSITE-68769 : 이벤트 메뉴 내 제품카테고리 필터 변경 요청
                self.$tabContents = self.$KRP0022.find('div.tabs-contents');

                self.saved_eventStatus = '';

                var _self = this;

                var categoryId = searchParam('categoryId');

                // BTOCSITE-5938-514 : IE에서 history back 시 이전에 선택된 필터 적용안되는 이슈 처리
                self.KRPOO22_history_data = 'KRPOO22_history_data';
                self.historyData = lgkorUI.getStorage(self.KRPOO22_history_data);

                _self.bindEvents();
                _self.checkNoData();

                if(categoryId == null){
                    if(Object.keys(self.historyData).length){
                        // 상단 tab 카테고리 영역 설정
                        self.$tab.find('ul.tabs li').removeClass('on');
                        self.$tab.find('ul.tabs li a[href="#'+self.historyData.eventStatus+'"]').parent('li').addClass('on');

                        self.$tabContents.find('ul.tabs li').removeClass('on');
                        self.$tabContents.find('ul.tabs li a[href="#'+self.historyData.categoryId+'"]').parent('li').addClass('on');

                        self.$KRP0022.find("#eventStatus").val(self.historyData.eventStatus);
                        self.$KRP0022.find("#eventGubun").val(self.historyData.eventGubun);
                        self.$KRP0022.find("#eventGubun").vcSelectbox('update');

                        _self.requestData(true,self.historyData.categoryId, true);

                    } else {
                        self.$tabContents.find('ul.tabs li').removeClass('on');
                        self.$tabContents.find('ul.tabs li a[href="#all"]').parent('li').addClass('on');
                    }

                }else{
                    _self.requestDataDefault(true, true);
                    self.$tabContents.find('ul.tabs li').removeClass('on');
                    self.$tabContents.find('ul.tabs li a[href="#'+categoryId+'"]').parent('li').addClass('on');
                }
            },

            bindEvents: function() {
                var _self = this;

                //온라인/매장 셀렉트 박스 change event
                self.$KRP0022.find('.ui_selectbox').on('change', function(e) {
                    _self.requestData(false, "", false);
                });

                //텝 클릭
                self.$tab.on("stickyTabchange", function(e, _obj) {
                    if(_obj.selectedIndex === 0){
                        self.$KRP0022.find("#eventStatus").val('progress');
                    } else if(_obj.selectedIndex === 1) {
                        self.$KRP0022.find("#eventStatus").val('end');
                    } else {
                        self.$KRP0022.find("#eventStatus").val('win');
                    }

                    self.$tabContents.find('ul.tabs li').removeClass('on');
                    self.$tabContents.find('ul.tabs li a[href="#all"]').parent('li').addClass('on');

                    _self.requestData(false, "", true);
                });

                self.$list.on('click', 'div.list-inner a.btn-link', function(e) {
                    e.preventDefault();
                    _self.requestModal(this);
                });



                //BTOCSITE-77414 웹접근성

                self.$tabContents.on('click',function(e){
                    if(e.isTrigger){
                        self.$tabContents.find('ul.tabs li a .blind').remove()
                        for(var i=0; i < self.$tabContents.find('ul.tabs li').length; i++){
                            if(self.$tabContents.find('ul.tabs li').eq(i).hasClass('on')){
                                self.$tabContents.find('ul.tabs li').eq(i).find('a').append('<em class="blind">선택됨</em>')
                            }
                        }
                    }else if($(e.target)[0]['nodeName'] === 'A'){
                        self.$tabContents.find('ul.tabs li a .blind').remove()
                        $(e.target).append('<em class="blind">선택됨</em>')
                   }
                })
                setTimeout(function(){
                    self.$tabContents.trigger('click');
                },100)
                
                ////BTOCSITE-77414 웹접근성


            },

            noData: function(visible) {
                if(visible) {
                    self.$noData.show();
                } else {
                    self.$noData.hide();
                }
            },

            checkNoData: function() {
                var _self = this;
                _self.noData(self.$list.find('li').length > 0 ? false : true);
            },

            requestData: function(isOnLoad, categoryId, isTabClick) {
                //console.log("requestData");
                var _self = this;
                var ajaxUrl = self.$KRP0022.attr('data-list-url');
                var selectIdx = self.$tabContents.find('ul.tabs li.on').index();
                var selectedCategory = self.$tabContents.find('ul.tabs li:eq(' + selectIdx +') a').attr('href').replace("#", "");

                //console.log("selectIdx : " ,selectIdx);
                //console.log("before selectedCategory : " ,selectedCategory);

                if(categoryId != ""){
                    selectedCategory = categoryId;
                    //console.log("after selectedCategory : " ,selectedCategory);
                }

                var postData = {"categoryId":selectedCategory};

                var selStatusIdx = self.$tab.find('ul.tabs li.on').index();
                var selectedStatus = self.$tab.find('ul.tabs li:eq(' + selStatusIdx +') a').attr('href').replace("#", "");

                //console.log("선택된 탭 : " ,selectedStatus);
                //console.log("eventStatus val check : ", self.$KRP0022.find("#eventStatus").val() != "");

                if(self.$KRP0022.find("#eventStatus").val() != ""){
                    selectedStatus = self.$KRP0022.find("#eventStatus").val();
                }

                //console.log("최종 텝 상태 : " ,selectedStatus);

                postData["eventStatus"] = selectedStatus;

                //console.log('ajaxUrl : ',ajaxUrl);
                //console.log('selectedStatus : ',selectedStatus);
                //console.log('selectedCategory : ',selectedCategory);

                var eventGubun;

                self.$KRP0022.find('.ui_selectbox').each(function (index, item) {
                    var $item = $(item);
                    postData[$item.attr('id')] = $item.vcSelectbox('value');
                    eventGubun = $item.vcSelectbox('value');
                });

                // BTOCSITE-5938-514 : postData session storage에 저장
                if(!isOnLoad) { // 첫 load 시 미실행
                    lgkorUI.setStorage(self.KRPOO22_history_data, postData, false);
                }

                //console.log('postData : ',postData);

                // lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function(result){
                //     //console.log('result',result);
                //     //console.log('result.data',result.data);
                //     _self.updateList(result.data, selectedCategory, isTabClick);
                // });

                lgkorUI.requestKongAjax("eventsvc", "/ajax/v1/event/retrieveEventList", {
                    method: "POST",
                    data: {
                        categoryId: selectedCategory,
                        eventStatus: selectedStatus,
                        eventGubun: eventGubun
                    },
                    success: function(result) {
                        _self.updateList(result.data, selectedCategory, isTabClick);
                    },
                    error: function(jqXHR) {
                        console.log(jqXHR)
                    }
                });

            },

            requestDataDefault: function(isOnLoad, isTabClick) {
                //console.log("requestDataDefault");
                var _self = this;
                var categoryId = searchParam('categoryId');

                var ajaxUrl = self.$KRP0022.attr('data-list-url');
                var selectIdx = self.$tabContents.find('ul.tabs li.on').index();
                var selectedCategory = self.$tabContents.find('ul.tabs li:eq(' + selectIdx +') a').attr('href').replace("#", "");

                //console.log("selectIdx : " ,selectIdx);
                //console.log("before selectedCategory : " ,selectedCategory);

                if(categoryId != null){
                    selectedCategory = categoryId;
                    //console.log("after selectedCategory : " ,selectedCategory);
                }

                var postData = {"categoryId":selectedCategory};

                var selStatusIdx = self.$tab.find('ul.tabs li.on').index();
                var selectedStatus = self.$tab.find('ul.tabs li:eq(' + selStatusIdx +') a').attr('href').replace("#", "");

                //console.log("선택된 탭 : " ,selectedStatus);
                //console.log("eventStatus val check : ", self.$KRP0022.find("#eventStatus").val() != "");

                if(self.$KRP0022.find("#eventStatus").val() != ""){
                    selectedStatus = self.$KRP0022.find("#eventStatus").val();
                }

                //console.log("최종 텝 상태 : " ,selectedStatus);

                postData["eventStatus"] = selectedStatus;

                //console.log('ajaxUrl : ',ajaxUrl);
                //console.log('selectedStatus : ',selectedStatus);
                //console.log('selectedCategory : ',selectedCategory);

                var eventGubun;

                self.$KRP0022.find('.ui_selectbox').each(function (index, item) {
                    var $item = $(item);
                    postData[$item.attr('id')] = $item.vcSelectbox('value');
                    eventGubun = $item.vcSelectbox('value');
                });

                // BTOCSITE-5938-514 : postData session storage에 저장
                if(!isOnLoad) { // 첫 load 시 미실행
                    lgkorUI.setStorage(self.KRPOO22_history_data, postData, false);
                }

                //console.log('postData : ',postData);

                // lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function(result){
                //     //console.log('result',result);
                //     //console.log('result.data',result.data);
                //     _self.updateList(result.data, selectedCategory, isTabClick);
                // });

                // 신규 API 호출 되도록 수정
                lgkorUI.requestKongAjax("eventsvc", "/ajax/v1/event/retrieveEventList", {
                    method: "POST",
                    data: {
                        categoryId: selectedCategory,
                        eventStatus: selectedStatus,
                        eventGubun: eventGubun
                    },
                    success: function(result) {
                        _self.updateList(result.data, selectedCategory, isTabClick);
                    },
                    error: function(jqXHR) {
                        console.log(jqXHR)
                    }
                });
            },

            updateList: function(data, categoryId, isTabClick) {
                var _self = this;
                self.$list.empty();
                var arr =  data;
                var eventList = arr.eventList;

                //BTOCSITE-68769 : 이벤트 메뉴 내 제품카테고리 필터 변경 요청 START
                $("#totalEvtCnt").text(eventList.length);

                var categoryList = arr.categoryList;

                if(categoryList.length > 0 && isTabClick){
                    self.$tabContents.find('ul.tabs').empty();
                    self.$tabContents.find('ul.tabs').append(vcui.template(allCategory, ""));

                    categoryList.forEach(function(item, index) {
                        self.$tabContents.find('ul.tabs').append(vcui.template(eventCategoryList, item));
                    });

                    self.$tabContents.find('ul.tabs li').removeClass('on');
                    self.$tabContents.find('ul.tabs li a[href="#'+categoryId+'"]').parent('li').addClass('on');
                    self.$tabContents.vcSmoothScroll('refresh');
                } else {
                    self.$tabContents.vcSmoothScroll('refresh');
                }
                //BTOCSITE-68769 : 이벤트 메뉴 내 제품카테고리 필터 변경 요청 END

                eventList.forEach(function(item, index) {
                    item.eventType = item.eventType ? item.eventType : "";
                    item.eventId = item.eventId ? item.eventId : null;

                    /* BTOCSITE-2065 : 이벤트&기획전 페이지 내 데이터레이어 삽입 (수정 작업 요청) 2021-09-02 */
                    var ecPromotion = {
                        "promo_id": item.eventUrl,
                        "promo_name": item.eventTitle,
                        "promo_creative": item.eventListThumbnailPath
                    }
                    item.ecPromotion = JSON.stringify(ecPromotion);
                    /* //BTOCSITE-2065 : 이벤트&기획전 페이지 내 데이터레이어 삽입 (수정 작업 요청) 2021-09-02 */

                    self.$list.append(vcui.template(eventItemList, item));
                });

                vcui.PubSub.trigger('onLazyLoaderPath');

                _self.checkNoData();
            },

            requestModal: function(dm) {
                var _self = this;
                var ajaxUrl = $(dm).attr('href');
                window.open(ajaxUrl,'','width=912,height=760,scrollbars=yes');
            },
        };

        $(document).on('ready',function() {
            $('.ui_stickyTab').addClass('no-init');
            vcui.require([
                'ui/stickyTab',
            ], function () {
                $('.ui_stickyTab').vcStickyTab();
                KRP0022.init();
            });
        });

        //BTOCSITE-68769 : 이벤트 메뉴 내 제품카테고리 필터 변경 요청 : 카테고리 클릭 이벤트
        $(document).on("click", ".KRP0022 div.tabs-contents ul.tabs li a", function (e) {
            //console.log("카테고리 클릭");
            e.preventDefault();

            var id = $(this).attr('href').replace("#", "");
            var $tabContents = $('.KRP0022').first().find('div.tabs-contents');

            $tabContents.find('ul.tabs li').removeClass('on');
            $tabContents.find('ul.tabs li a[href="#'+id+'"]').parent('li').addClass('on');

            KRP0022.requestData(false, id, false);
        });

    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0022', isFirstLoad: false, fn: function () {
                funcReady();
            }
        });
    }

    function searchParam(key){
        return new URLSearchParams(location.search).get(key);
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function() {
        SAVE_COMPONENT_PDP_DOM_MNG();

        funcReady();
    });

    //개별페이지별 이벤트가 먼저 등록되면 이벤트 삭제 방지 변수
    var lazyLoaderPath = false;
    vcui.PubSub.on('onLazyLoaderBefore',function(){
      //console.log('기본이벤트 등록전 개별페이지 vcLazyLoader 이벤트 등록');
      var $b = $('body');
      if(!lazyLoaderPath){
          var obj = $b.data()
          delete obj.ui_lazyLoader;
          $b.vcLazyLoader({useFade: true, useNewJs:true});
      }
    }).on('onLazyLoaderPath',function(){
        //console.log('업데이트 onLazyLoader 이벤트 등록');
        var $b = $('body');
        if(lazyLoaderPath){
            $b.data('ui_lazyLoader').reload();
            return;
        }
        if( $b.vcLazyLoader ){
            var obj = $b.data()
            delete obj.ui_lazyLoader;
            $b.vcLazyLoader({useFade: true, useNewJs:true,});
            lazyLoaderPath = true;
        }else{
            vcui.require([
                'ui/lazyLoader',
            ], function () {
                var obj = $b.data()
                delete obj.ui_lazyLoader;
                $b.vcLazyLoader({useFade: true, useNewJs:true,});
                lazyLoaderPath = true;
            });
        }
    });

})();